import FabricCanvasTool from "../fabrictool";
import { getDrawStyleProps } from '../../../../../utils/CanvasTool'

class Pencil extends FabricCanvasTool {
  configureCanvas(props) {
    this._canvas.isDrawingMode = true;
    // Use draw-popup line width (was hardcoded to 1/zoom).
    this._drawStyle = getDrawStyleProps(props.lineColor, props.lineWidth);
    this._canvas.freeDrawingBrush.width = this._drawStyle.strokeWidth;
    this._canvas.freeDrawingBrush.color = this._drawStyle.stroke;
    this.props = props
  }
}

export default Pencil;
